import ApiService from '../api.service';

const Schools = {
  index: () => ApiService.get('/api/v2/teachers/me/schools'),
};

export default Schools;
